import React, { Component } from 'react'
import { Form } from 'semantic-ui-react'

class PasswordInput extends Component{
  constructor (props) {
    super(props)
    this.state = {
      label: (props.label ? props.label : ''),
      value: props.value,
      placeholder: (props.placeholder ? props.placeholder : ''),
      type: 'password',
      disabled: (props.disabled ? props.disabled : false)
    }
    this.handleChangeSecretValue = this.handleChangeSecretValue.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.disabled !== nextProps.disabled) {
      this.setState({disabled: nextProps.disabled})
    }
  }

  showHide = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({
      type: this.state.type === 'input' ? 'password' : 'input'
    })
  }

  handleChangeSecretValue (event) {
    this.setState({value: event.target.value})
    this.props.onHandleSecretValueChanged(event)
  }

  render () {
    const { disabled, value } = this.state
    return (
      <div className='password-field'>
        <Form.Input
          label={this.state.label}
          placeholder={this.state.placeholder}
          type={this.state.type}
          value={value}
          error={this.props.error}
          disabled={disabled}
          onChange={this.handleChangeSecretValue} />
        <div
          className={(disabled ? 'password-field-disabled' : 'password-field-enabled')}
          onClick={this.showHide}>
          {this.state.type === 'input' ? 'Hide' : 'Show'}
        </div>
      </div>
    )
  }
}

class PasswordLabel extends Component {
  constructor (props) {
    super(props)
    this.state = {
      value: props.value,
      type: 'password'
    }
  }

  showHide = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({
      type: this.state.type === 'input' ? 'password' : 'input'
    })
  }

  render () {
    const { type, value } = this.state
    return (
      <div className='password-field'>
        {type === 'input' ? value : '*'.repeat(value.length - 4).concat(value.slice(value.length - 4, value.length))}&nbsp;&nbsp;
        <div className='password-link-toggle' onClick={this.showHide}>
          {type === 'input' ? 'Hide' : 'Show'}
        </div>
      </div>
    )
  }
}

export { PasswordInput, PasswordLabel }



// WEBPACK FOOTER //
// ./src/components/PasswordField.js